import { supportsWebp } from '@cvent/nucleus-image';

export default async function detectBrowserFeatures() {
  return {
    supportsWebp: await supportsWebp()
  };
}
